(function () {
  const miniCart = document.getElementById('mini-cart');
  if (!miniCart) return;

  let isAdding = false;
  let scrollY = 0;

  // ---------------- Scroll lock ----------------
  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.cssText = `
      position: fixed;
      top: -${scrollY}px;
      left: 0;
      right: 0;
      width: 100%;
    `;
    document.documentElement.classList.add('drawer-open');
    document.body.classList.add('drawer-open');
  }

  function unlockScroll() {
    document.body.style.cssText = 'Product Added';
    document.documentElement.classList.remove('drawer-open');
    document.body.classList.remove('drawer-open');
    window.scrollTo(0, scrollY);
  }

  // ---------------- Drawer ----------------
  function openDrawer() {
    if (miniCart.parentElement !== document.body || document.body.lastElementChild !== miniCart) {
      document.body.appendChild(miniCart);
    }
    miniCart.classList.add('open');
    lockScroll();
  }

  function closeDrawer() {
    miniCart.classList.remove('open');
    unlockScroll();
  }

  window.openMiniCart = openDrawer;
  window.closeMiniCart = closeDrawer;

  // ---------------- Helpers ----------------
  function qs(selector, scope = document) {
    return scope.querySelector(selector);
  }

  function qsa(selector, scope = document) {
    return [...scope.querySelectorAll(selector)];
  }

  function debounce(fn, delay = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  async function fetchJSON(url, options = {}) {
    const res = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(options.headers || {}) },
      ...options
    });

    if (!res.ok) {
      let err = {};
      try {
        err = await res.json();
      } catch (_) {}
      throw new Error(err.description || 'Request failed.');
    }

    return res.json();
  }

  async function fetchText(url, options = {}) {
    const res = await fetch(url, {
      credentials: 'same-origin',
      ...options
    });

    if (!res.ok) throw new Error('Request failed.');
    return res.text();
  }

  // ---------------- Cart count ----------------
  function setCartCount(count) {
    qsa('[data-cart-count-badge]').forEach((el) => {
      el.textContent = count;
      el.closest('.cart-count-bubble')?.classList.toggle('hidden', count <= 0);
    });

    qsa('[data-cart-count-text]').forEach((el) => {
      el.textContent = count;
    });

    const fallbackBadge = qs('#open-mini-cart > div');
    if (fallbackBadge) fallbackBadge.textContent = count;

    const label = qs('#open-mini-cart .text-link');
    if (label) {
      const text = label.textContent || '';
      label.textContent = /\(\s*\d+\s*\)/.test(text)
        ? text.replace(/\(\s*\d+\s*\)/, `(${count})`)
        : `${text.trim()} (${count})`;
    }

    const headerCart = qs('#open-mini-cart');
    if (headerCart) {
      headerCart.setAttribute('aria-live', 'polite');
      headerCart.setAttribute('aria-atomic', 'true');
    }

    document.dispatchEvent(
      new CustomEvent('cart:count-updated', { detail: { count } })
    );
  }

  async function syncCartCount() {
    try {
      const cart = await fetchJSON('/cart.js');
      setCartCount(cart.item_count || 0);
    } catch (err) {
      console.error('Cart count sync failed:', err);
    }
  }

  // ---------------- Mini cart refresh ----------------
  async function refreshMiniCart() {
    const html = await fetchText('/cart?view=mini-cart');
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const fresh = qs('.mini-cart-content', doc);
    const current = qs('.mini-cart-content', miniCart);

    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  // ---------------- Cart update ----------------
  async function changeLineQty(key, quantity) {
    const body = new URLSearchParams({
      id: key,
      quantity: String(quantity)
    });

    await fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body
    });
  }

  async function addToCart(form) {
    const data = new FormData(form);

    await fetchJSON('/cart/add.js', {
      method: 'POST',
      body: data
    });
  }

  async function updateCartUI() {
    await Promise.all([refreshMiniCart(), syncCartCount()]);
  }

  // ---------------- Manual open / close ----------------
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('#open-mini-cart, [data-open-mini-cart]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = e.target.closest('[data-close-mini-cart]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const checkoutBtn = e.target.closest('[data-checkout]');
    if (checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = checkoutBtn.getAttribute('href') || '/checkout';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && miniCart.classList.contains('open')) {
      closeDrawer();
    }
  });

  // ---------------- Prevent background scroll on iOS ----------------
  document.addEventListener(
    'touchmove',
    (e) => {
      if (!document.body.classList.contains('drawer-open')) return;
      if (!e.target.closest('.mini-cart-panel')) e.preventDefault();
    },
    { passive: false }
  );

  // ---------------- Add to cart ----------------
  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest(
        'form[action*="/cart/add"] [type="submit"], [data-add-to-cart]'
      );
      if (!btn) return;

      const form = btn.closest('form[action*="/cart/add"]');
      if (!form || isAdding || form.dataset.processing === '1') return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      isAdding = true;
      form.dataset.processing = '1';

      const wasDisabled = btn.disabled;
      btn.disabled = true;

      try {
        await addToCart(form);
        await updateCartUI();
        // intentionally not auto-opening cart
      } catch (err) {
        console.error('Add to cart error:', err);
        alert(err.message || 'Something went wrong adding to cart.');
      } finally {
        isAdding = false;
        delete form.dataset.processing;
        btn.disabled = wasDisabled;
      }
    },
    true
  );

  // ---------------- Qty buttons / remove ----------------
  miniCart.addEventListener('click', async (e) => {
    const item = e.target.closest('.mini-cart-item');
    if (!item) return;

    const key = item.getAttribute('data-line-key');
    const input = qs('[data-qty-input]', item);
    const current = parseInt(input?.value || '1', 10) || 1;

    let nextQty = null;

    if (e.target.closest('[data-qty="up"]')) {
      e.preventDefault();
      nextQty = current + 1;
    } else if (e.target.closest('[data-qty="down"]')) {
      e.preventDefault();
      nextQty = Math.max(0, current - 1);
    } else if (e.target.closest('[data-remove]')) {
      e.preventDefault();
      nextQty = 0;
    }

    if (nextQty === null) return;

    try {
      await changeLineQty(key, nextQty);
      await updateCartUI();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Cart update failed.');
    }
  });

  // ---------------- Qty input typing ----------------
  const onQtyInput = debounce(async (input) => {
    const item = input.closest('.mini-cart-item');
    if (!item) return;

    const key = item.getAttribute('data-line-key');
    let value = parseInt(input.value || '0', 10);
    if (isNaN(value) || value < 0) value = 0;

    try {
      await changeLineQty(key, value);
      await updateCartUI();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Cart update failed.');
    }
  }, 400);

  miniCart.addEventListener('input', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      onQtyInput(e.target);
    }
  });

  // ---------------- Init ----------------
  syncCartCount();
})();